import { combineReducers } from 'redux'

import itensDetalhamentoLancamento from './ItensDetalhamentoLancamento'

export default combineReducers({ itensDetalhamentoLancamento })
